import { LoadingAnimationLabelPosition, LoadingAnimationSize, LogoSize } from '@cmctechnology/webinvest-design-system';

export const SG_LOGIN_PATH = `/sg/login`;
export const AU_LOGIN_PATH = `/au/login`;
export const LOCALSTORAGE_THEME = 'Theme';
export const TIMEOUT_DEFAULT_MINUTES = 20;
export const MS_TO_MINUTE = 60_000;
export const SESSION_EXPIRED = 'session-expired';

export const SPLASH_SCREEN_PROPS = {
  label: 'Loading',
  labelPosition: 'below' as LoadingAnimationLabelPosition,
  loaderSize: 'small' as LoadingAnimationSize,
  logoSize: 'large' as LogoSize
};
